import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 41 46",
  "content": "<symbol viewBox=\"0 0 41 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 24H0v-2h32v2z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.822.43L40.21 22.611 24.83 45.516 23.17 44.4l14.62-21.77L23.178 1.57 24.822.43z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id